import React from 'react';
import { Box, Typography } from '@availity/element';
import { useNavigate } from 'react-router-dom';
import Button from '../../Utils/components/Button';
import contactBg from '../../../static/assets/backgrounds/contact-callout-bg.jpg';
import readinessForProductionIcon from '../../../static/assets/illustrations/ReadinessforProduction.svg';

const NetworkVisualization = () => (
  <img src={readinessForProductionIcon} alt="Readiness for Production network visualization" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
);

const EndCapSection = () => {
  const navigate = useNavigate();

  return (
  <Box className="endcap-section">
    <Box
      className="endcap-section__container"
      sx={{ flexDirection: { xs: 'column', lg: 'row' } }}
    >
      <Box
        className="endcap-section__left"
        sx={{
          width: { xs: 1, lg: 911 },
          px: { xs: 3, sm: 15.5, lg: 15.5 },
          py: { xs: 8, sm: 19.25, lg: 19.25 },
          gap: 5,
          '&::before': {
            backgroundImage: `url(${contactBg})`,
          },
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography
            className="endcap-section__title"
            sx={{ fontSize: { xs: 36, md: 36 } }}
          >
            Ready to Build?
          </Typography>
          <Typography 
            className="endcap-section__text"
            sx={{ fontSize: { xs: 18, md: 18 } }}
          >
            Start your integration journey today with our easy onboarding process.
          </Typography>
        </Box>

        <Box className="endcap-section__form">
          <Button 
            variant="navbar" 
            onClick={() => navigate('/docs/overview')}
            sx={{ 
              width: { xs: 'auto', sm: 'auto' },
              height: { xs: '40px', sm: 'auto' },
              padding: { xs: '8px 22px', sm: 'auto' },
              minWidth: { xs: 'auto', sm: 'auto' },
              borderRadius: { xs: '100px', sm: 'auto' },
              flexShrink: 0,
              whiteSpace: 'nowrap',
            }}
          >
            Explore APIs
          </Button>
        </Box>
      </Box>

      <Box
        className="endcap-section__right"
        sx={{
          width: { xs: 1, lg: 536 },
          px: { xs: 3, lg: 8 },
          py: { xs: 8, lg: 3 },
          gap: 3,
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Box 
            className="endcap-section__badge"
            sx={{ 
              width: 95,
              height: 25,
              px: 1.5,
              py: 1,
              background: '#BF4D17',
              borderRadius: 100,  
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Typography sx={{ fontSize: { xs: 12, md: 14 } }}>
              Coming Soon
            </Typography>
          </Box>
        </Box>

        <Box className="endcap-section__process-box" sx={{ pt: 3.75 }}>
          <Box sx={{ display: 'block' }}>
            <NetworkVisualization />
          </Box>
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, textAlign: 'center' }}>
          <Typography 
            className="endcap-section__readiness-title"
          >
            Readiness for Production
          </Typography>
          <Typography 
            className="endcap-section__readiness-text"
          >
            A pre-configured environment in the Availity Platform for testing and minimizing integration errors.
          </Typography>
        </Box>
      </Box>
    </Box>
  </Box>
);
};

export default EndCapSection;